import axios from '../../../axios';
import MonsterSearch from '../types/MonsterSearch';

export const searchMonster = async (query: MonsterSearch) =>
  await axios.post('/candidatesearch/api/monster/search', query);
export const monsterPowerSearch = async (query: MonsterSearch) =>
  await axios.post('/candidatesearch/api/monster/power-search', query);
export const updateMonsterCreditsData = (jobBoard: string) =>
  axios.post(`/candidatesearch/api/monster/update-credits/${jobBoard}`);
